import { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    RadioGroup,
    Radio,
    Stack,
    Text,
    useToast,
} from "@chakra-ui/react";
import { exportLaporanToExcel, filterLaporan } from "utils/ExportExcel";

export default function ExportExcelModal({ isOpen, onClose, allFlatRows }) {
    const [mode, setMode] = useState("periode"); // "periode" | "upi"
    const [dari, setDari] = useState("");
    const [sampai, setSampai] = useState("");
    const [nmUpi, setNmUpi] = useState("");
    const toast = useToast();

    const handleExport = () => {
        const filtered =
            mode === "periode"
                ? filterLaporan(allFlatRows, { dari, sampai })
                : filterLaporan(allFlatRows, { nmUpi });

        if (filtered.length === 0) {
            toast({
                title: "Tidak ada data",
                description: "Tidak ditemukan data sesuai filter yang dipilih",
                status: "warning",
                duration: 3000,
            });
            return;
        }

        exportLaporanToExcel(filtered, {
            fileName: mode === "upi" && nmUpi ? `Laporan_${nmUpi}` : "Laporan_Pengujian",
        });
        toast({
            title: "Export berhasil",
            description: `${filtered.length} baris data diexport`,
            status: "success",
            duration: 2500,
        });
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Rekap ke Excel</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="sm" color="gray.600" mb={4}>
                        Pilih berdasarkan apa data akan direkap.
                    </Text>
                    <RadioGroup value={mode} onChange={setMode} mb={4}>
                        <Stack direction="row" spacing={5}>
                            <Radio value="periode">Periode Tanggal</Radio>
                            <Radio value="upi">Nama UPI</Radio>
                        </Stack>
                    </RadioGroup>

                    {mode === "periode" ? (
                        <Stack direction="row" spacing={3}>
                            <FormControl>
                                <FormLabel fontSize="sm">Dari Tanggal</FormLabel>
                                <Input
                                    type="date"
                                    value={dari}
                                    onChange={(e) => setDari(e.target.value)}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel fontSize="sm">Sampai Tanggal</FormLabel>
                                <Input
                                    type="date"
                                    value={sampai}
                                    onChange={(e) => setSampai(e.target.value)}
                                />
                            </FormControl>
                        </Stack>
                    ) : (
                        <FormControl>
                            <FormLabel fontSize="sm">Nama UPI</FormLabel>
                            <Input
                                placeholder="Contoh: PT. Sahabat Bahari Internasional"
                                value={nmUpi}
                                onChange={(e) => setNmUpi(e.target.value)}
                            />
                        </FormControl>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose}>
                        Batal
                    </Button>
                    <Button colorScheme="green" onClick={handleExport}>
                        Download Excel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}